import { LockOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { BUTTON_KEYS, BUTTON_TYPE } from "@/constants/Button";

import { useForceChangePassword } from "./ForceChangePasswordButton.hook";

const ForceChangePasswordButton = ({ user, buttonProps }) => {
  const { t } = useTranslation();
  const { onForceChangePassword } = useForceChangePassword(user);

  return (
    <Button
      icon={<LockOutlined />}
      key={BUTTON_KEYS.FORCE_CHANGE_PASSWORD}
      type={BUTTON_TYPE.TEXT}
      onClick={onForceChangePassword}
      {...buttonProps}
    >
      {t("user:forceChangePassword.button")}
    </Button>
  );
};

export default ForceChangePasswordButton;
